import { green, red, yellow } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app

const theme = createTheme({
  typography: {
    fontFamily: '"Prompt", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
    },
  },

  palette: {
    amber: {
      main: '#ffc107',
    },
    primary: {
      main: '#4FA893;',
      light: '#96BAFF',
      dark: '#5CC1A9;',
    },
    cyan: {
      main: '#00bcd4',
    },
    secondary: {
      main: '#fff',
    },
    indigo: {
      main: '#3f51b5',
    },
    error: {
      main: red.A400,
    },
    warning: {
      main: yellow[800],
    },
    success: {
      main: green[500],
    },
    lightGreen: {
      main: '#4FA893',
      text: '#fff',
    },
    gray: {
      main: '#9e9e9e',
    },
    teal: {
      100: '#68B2A0',
      200: '#4FA893',
      300: '#5CC1A9',
    },
    // background: { default: '#c8e6c9' },

    // 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)'
  },
});

export default theme;
